<template>
  <table class="table has-text-left">
    <tbody>
    <tr>
      <td class="pl-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="check-icon" width="32" height="32" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
      </td>
      <td class="pr-0">
        <h4 class="mb-1">{{ description.top.title }}</h4>
        <p class="is-size-8" v-if="description.top.description">{{ description.top.description }}</p>
      </td>
    </tr>
    <tr>
      <td class="pl-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="check-icon" width="32" height="32" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
      </td>
      <td class="pr-0">
        <h4 class="mb-1">{{ description.middle.title }}</h4>
        <p class="is-size-8" v-if="description.middle.description">{{ description.middle.description }}</p>
      </td>
    </tr>
    <tr>
      <td class="border-b pl-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="check-icon" width="32" height="32" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
      </td>
      <td class="border-b pr-0">
        <h4 class="mb-1">{{ description.bottom.title }}</h4>
        <p class="is-size-8" v-if="description.bottom.description">{{ description.bottom.description }}</p>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "Description",
  props: {
    description: Object,
  },
}
</script>

<style lang="scss" scoped>
.border-b {
  border-bottom: 1px solid #dbdbdb !important;
}

.check-icon {
  color: #00EF00;
}

table {
  background-color: transparent;
}

@media (min-width: 769px) {
  p, h4 {
    color: #fff;
  }
}

.enneagram {
  h4 {
    font-weight: 400;
  }

  .check-icon {
    color: #E2D400;
  }

  @media (max-width: 768px) {
    td:first-child {
      padding-top: 0;
    }

    .check-icon {
      width: 38px;
      height: 38px;
    }

    h4 {
      font-size: 1em;
      font-weight: 600;
    }

    td {
      padding-left: 0;
    }

    .border-b {
      border-bottom: 5px solid #36895F !important;
    }

    .check-icon {
      color: #36895F;
    }
  }
}
</style>